import { useEffect, useState, useRef } from "react";

import { Button } from "primereact/button";

export default function useCaptcha() {
  const [captchaSetting, setCaptchaSetting] = useState({
    code: "",
    refresh: true,
  });
  const [setting, setSetting] = useState({
    code: "",
    codeLength: 6,
    fontSizeMin: 20,
    fontSizeMax: 22,
    backgroundColorMin: 230,
    backgroundColorMax: 250,
    colorMin: 0,
    colorMax: 0,
    lineColorMin: 30,
    lineColorMax: 180,
    contentWidth: 96,
    contentHeight: 28,
  });
  const canvas = useRef("");

  useEffect(() => {
    if (!captchaSetting.refresh) return;

    drawPic();
  }, [captchaSetting]);

  // 生成一个随机数
  const randomNum = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min);
  };

  const drawPic = () => {
    randomCode();
  };

  const randomColor = (min, max) => {
    const r = randomNum(min, max);
    const g = randomNum(min, max);
    const b = randomNum(min, max);
    return `rgb(${r}, ${g}, ${b})`;
  };

  const drawText = (ctx, txt, i, code) => {
    ctx.fillStyle = randomColor(setting.colorMin, setting.colorMax);
    let fontSize = randomNum(setting.fontSizeMin, setting.fontSizeMax);
    ctx.font = "bold " + fontSize + "px SimHei";
    let padding = 10;
    let offset = (setting.contentWidth - 30) / (code.length - 1);
    let x = padding;
    if (i > 0) {
      x = padding + i * offset;
    }
    // let y = randomNum(setting.fontSizeMax, setting.contentHeight - 5);
    let y = 26;
    // if (fontSize > 30) {
    //   y = 30;
    // }
    let deg = randomNum(-10, 10);
    // 修改坐标原点和旋转角度
    ctx.translate(x, y);
    // ctx.rotate((deg * Math.PI) / 180);
    ctx.fillText(txt, 0, 0);
    // 恢复坐标原点和旋转角度
    // ctx.rotate((-deg * Math.PI) / 180);
    ctx.translate(-x, -y);
  };

  const drawLine = (ctx) => {
    // 绘制干扰线
    for (let i = 0; i < 1; i++) {
      ctx.strokeStyle = randomColor(setting.lineColorMin, setting.lineColorMax);
      ctx.beginPath();
      ctx.moveTo(
        randomNum(0, setting.contentWidth),
        randomNum(0, setting.contentHeight)
      );
      ctx.lineTo(
        randomNum(0, setting.contentWidth),
        randomNum(0, setting.contentHeight)
      );
      ctx.stroke();
    }
  };

  const drawDot = (ctx) => {
    // 绘制干扰点
    for (let i = 0; i < 100; i++) {
      ctx.fillStyle = randomColor(0, 255);
      ctx.beginPath();
      ctx.arc(
        randomNum(0, setting.contentWidth),
        randomNum(0, setting.contentHeight),
        1,
        0,
        2 * Math.PI
      );
      ctx.fill();
    }
  };

  const randomCode = () => {
    // 随机生成验证码
    let random = "";
    // 去掉了I l i o O
    // const str = "QWERTYUPLKJHGFDSAZXCVBNMqwertyupkjhgfdsazxcvbnm1234567890";
    const str = "1234567890";
    for (let i = 0; i < setting.codeLength; i++) {
      let index = Math.floor(Math.random() * 10);
      random += str[index];
    }

    setCaptchaSetting((state) => ({
      ...state,
      code: random,
      refresh: false,
    }));
    setSetting((state) => ({ ...state, code: random }));

    let tmpCanvas = canvas.current;
    let ctx = tmpCanvas.getContext("2d");
    ctx.textBaseline = "bottom";
    // 绘制背景
    ctx.fillStyle = randomColor(
      setting.backgroundColorMin,
      setting.backgroundColorMax
    );
    ctx.fillRect(0, 0, setting.contentWidth, setting.contentHeight);
    // 绘制文字
    for (let i = 0; i < random.length; i++) {
      drawText(ctx, random[i], i, random);
    }
    drawLine(ctx);
    drawDot(ctx);
  };

  const reloadPic = () => {
    drawPic();
  };

  const playSound = () => {
    let synth = window.speechSynthesis;
    if (typeof synth === "undefined") {
      alert("不支援語音");
      return;
    } else if (captchaSetting.code === "") {
      alert("無驗證碼");
      return;
    }

    let code = captchaSetting.code.split("");
    code.forEach((item, index) => {
      let utterance = new SpeechSynthesisUtterance(item);
      utterance.rate = 0.5;
      synth.speak(utterance);
    });
  };

  const renderCaptcha = () => (
    <div className="flex align-items-center">
      {/* <Button
        type="button"
        className="p-button-secondary p-button-sm w-auto ml-auto mr-2"
        label="重新產生"
        onClick={() => reloadPic()}
      /> */}

      <canvas
        ref={canvas}
        width="100"
        height="30"
        style={{ marginTop: "1px" }}
      ></canvas>

      <Button
        type="button"
        className="p-button-secondary p-button-sm p-button-text ml-2"
        icon="pi pi-refresh"
        label="重新產生"
        onClick={() => reloadPic()}
      />
      <Button
        type="button"
        className="p-button-secondary p-button-sm p-button-text ml-2"
        icon="pi pi-volume-down"
        label="播放語音"
        onClick={() => playSound()}
      />
    </div>
  );

  return { captchaSetting, setCaptchaSetting, renderCaptcha };
}
